import { ICard, ECardType, ITypedCard } from '../types';

export function addTypesToCards(cards: ICard[], cardsTypes: ECardType[]): ITypedCard[] {
  return cards.map((card, index) => {
    let cardType = cardsTypes[index];

    if (cardType === undefined) {
      cardType = ECardType.VerticalHalfImage;
    }

    return { ...card, type: cardType };
  });
}
